import React from 'react'
import PropTypes from 'prop-types'
import {usePopperTooltip} from 'react-popper-tooltip'

function getClassModifier(modifier) {
  if (!modifier) {
    return ''
  }
  if (Array.isArray(modifier)) {
    return modifier.map(x => `tooltip--${x}`).join(' ')
  }
  return `tooltip--${modifier}`
}

export function Tooltip({
  modifier,
  trigger,
  children,
  placement = 'top-start',
  triggerAction = 'click',
  triggerModifier,
  testId,
}) {
  const {getArrowProps, getTooltipProps, setTooltipRef, setTriggerRef, visible} = usePopperTooltip({
    trigger: triggerAction,
    placement,
  })

  const containerModifier = getClassModifier(modifier)

  const triggerModifierClassNames = getClassModifier(triggerModifier)

  return (
    <div className={`tooltip ${triggerModifierClassNames}`} data-testid={testId}>
      <div ref={setTriggerRef} className="trigger">
        {trigger}
      </div>
      {visible && (
        <div
          ref={setTooltipRef}
          {...getTooltipProps({
            className: `tooltip-container ${containerModifier}`,
          })}>
          <div
            {...getArrowProps({
              className: `tooltip-arrow ${containerModifier}`,
            })}
          />
          {children}
        </div>
      )}
    </div>
  )
}

Tooltip.propTypes = {
  children: PropTypes.node,
  trigger: PropTypes.node,
  content: PropTypes.node,
  modifier: PropTypes.any,
  triggerModifier: PropTypes.any,
  placement: PropTypes.string,
  triggerAction: PropTypes.string,
  testId: PropTypes.string,
}

export default Tooltip
